import React from "react";

import { Minus, Plus } from "lucide-react";
import { DEFAULT_ZOOM, ZOOM_STEPS, ZOOM_STORAGE_KEY, getInitialZoom } from "./zoom";

export const ZoomControl = () => {
  const [zoom, setZoom] = React.useState<number>(getInitialZoom);
  const zoomIndex = ZOOM_STEPS.indexOf(zoom as (typeof ZOOM_STEPS)[number]);

  React.useLayoutEffect(() => {
    document.documentElement.style.setProperty("--app-zoom", String(zoom));
    window.localStorage.setItem(ZOOM_STORAGE_KEY, String(zoom));
  }, [zoom]);

  const decreaseZoom = () => {
    if (zoomIndex > 0) setZoom(ZOOM_STEPS[zoomIndex - 1]);
  };

  const increaseZoom = () => {
    if (zoomIndex < ZOOM_STEPS.length - 1) setZoom(ZOOM_STEPS[zoomIndex + 1]);
  };

  return (
    <div className="zoom-control" role="group" aria-label="화면 배율 조절">
      <button
        type="button"
        className="zoom-control-button"
        onClick={decreaseZoom}
        disabled={zoomIndex === 0}
        aria-label="화면 축소"
        title="화면 축소"
      >
        <Minus aria-hidden="true" />
      </button>
      <button
        type="button"
        className="zoom-control-value"
        onClick={() => setZoom(DEFAULT_ZOOM)}
        aria-label={`화면 배율 ${Math.round(zoom * 100)}%, 기본 배율로 초기화`}
        title="기본 배율로 초기화"
      >
        {Math.round(zoom * 100)}%
      </button>
      <button
        type="button"
        className="zoom-control-button"
        onClick={increaseZoom}
        disabled={zoomIndex === ZOOM_STEPS.length - 1}
        aria-label="화면 확대"
        title="화면 확대"
      >
        <Plus aria-hidden="true" />
      </button>
    </div>
  );
};
